"use client";

import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { useRouter } from "next/navigation";
import { Roboto } from "next/font/google";
import { useTranslation } from "react-i18next";

const roboto = Roboto({
  subsets: ["latin"],
  weight: ["300", "400", "500", "700"],
  display: "swap",
});

const FeautureExploreMore = () => {
  const router = useRouter();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const handleClick = () => {
    router.push("/free-trial-of-ai-recruiting-tool");
  };

  return (
    <Box
      sx={{
        backgroundColor: "#8871E6",
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: { xs: "20%", sm: "7%" },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: {
              xs: isArabic ? "right" : "left",
              sm: isArabic ? "right" : "left",
              md: "center",
              lg: "center",
              xl: "center",
            },
            gap: { xs: 1.5, sm: 2 },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              color: "white",
              fontWeight: "bold",
              marginBottom: 1,
              fontSize: {
                xs: "1.8rem",
                sm: "2.4rem",
                md: "1.4rem",
                lg: "2.4rem",
                xl: "3rem",
              },
              fontFamily: "var(--font-plusjakarta)",
              textAlign: {
                xs: isArabic ? "right" : "left",
                sm: isArabic ? "right" : "left",
                md: "center",
                lg: "center",
                xl: "center",
              },
            }}
          >
            {t("featureExploreMore.title")}
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{
              color: "rgba(255, 255, 255, 0.9)",
              marginBottom: 1,
              fontWeight: 300,
              fontSize: {
                xs: "0.9rem",
                sm: "1rem",
                md: "1rem",
                lg: "1rem",
                xl: "1.3rem",
              },
              fontFamily: "var(--font-outfit)",
              maxWidth: "750px",
              lineHeight: 1.5,
              textAlign: {
                xs: isArabic ? "right" : "left",
                sm: isArabic ? "right" : "left",
                md: "center",
                lg: "center",
                xl: "center",
              },
            }}
          >
            {t("featureExploreMore.subtitle")}
          </Typography>

          <Button
            onClick={handleClick}
            variant="contained"
            sx={{
              backgroundColor: "white",
              color: "#9048FB",
              fontFamily: "var(--font-outfit)",
              padding: { xs: "6px 20px", sm: "8px 25px", md: "10px 40px" },
              borderRadius: "19px",
              textTransform: "none",
              boxShadow: "none",
              fontWeight: "400",
              fontSize: {
                xs: "0.8rem",
                sm: "0.9rem",
                md: "0.9rem",
                lg: "0.9rem",
                xl: "1.1rem",
              },
              mt: "1%",
              "&:hover": {
                backgroundColor: "#000",
                color: "white",
                boxShadow: "none",
              },
            }}
          >
            {t("featureExploreMore.cta")}
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default FeautureExploreMore;
